module.exports = __webpack_public_path__ + "static/media/vienna-5.8f73f6f9.jpg";